import React, { Component, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import Loader from '../Shared/Loader/loader';
import AttributeTypes from '../Attributes/AttributeTypes';
import { RoleContext } from './Context/RoleContext';
import { accessMap, attachmentAccessMap } from './accessMap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { SavingComponent, InProgressComponent } from "./SavingComponent";
import { GlobalContext } from "../../Renderers/GlobalContext"
import WorkspaceAppModelContext from '../../Context/Workspace/WorkspaceAppModelContext';
import { withTranslation } from 'react-i18next';
import { getAttributes, updateAttribute } from '../../API/Attribute/Attribute';

function AttributeNameCell(props) {

    const navigate = useNavigate();
    const { mutators } = useContext(WorkspaceAppModelContext);

    function navigateToEntity() {
        if (mutators) {
            mutators.setSelectedTab(0);
            mutators.setSelectedEntity(props.entity.endNode);
            mutators.setSelectedAttribute(props.dataItem);
        } else {
            navigate(`/${props.organizationName}/${props.projectName}/Entities/${props.entity.endNode.sysName}/Attributes/${props.dataItem.sysName}`)
        }
    }

    return (
        <td title={props.dataItem.attributeName}>
            <span className="text-link" onClick={navigateToEntity}>
                {props.dataItem.attributeName}
            </span>
        </td>
    )
}

class AttributeRights extends Component {

    DataTypes = AttributeTypes.Types
    static contextType = RoleContext
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount = async () => {
        const { dispatch } = this.context
        let attributes = await this.getData()
        dispatch({ type: "SET_ATTRIBUTES", payload: attributes })
        dispatch({ type: "SET_ATTRIBUTE_LOADER", payload: false })
        if (attributes.length > 0) {
            this.selectItem(attributes[0])
        }
    }

    componentDidUpdate = async (props) => {
        if (props.selectedEntity._id && props.selectedEntity._id !== this.props.selectedEntity._id) {
            const { dispatch } = this.context
            let attributes = await this.getData()
            dispatch({ type: "SET_ATTRIBUTES", payload: attributes })
            dispatch({ type: "SET_ATTRIBUTE_LOADER", payload: false })
            if (attributes.length > 0) {
                this.selectItem(attributes[0])
            }
        }
    }

    render() {
        const { state } = this.context
        const { t } = this.props
        if (state.loadingAttributes) return <Loader />
        return (
            <div className='py-2'>
                <Grid
                    data={state.attributes.map((item) => ({
                        ...item,
                        selected: item._id === state.selectedAttribute._id
                    }))}
                    onRowClick={(e) => this.selectItem(e.dataItem)}
                    selectedField="selected"
                >
                    <Column field="indexId" title="#" width={40} />
                    <Column
                        title={t("grid.header.name")}
                        cell={(props) => (
                            <AttributeNameCell
                                {...props}
                                organizationName={this.props.orgName}
                                projectName={this.props.projectName}
                                entity={this.props.selectedEntity}
                            />
                        )}
                    />
                    {/* <Column
                        width={90}
                        title={t("grid.header.type")}
                        cell={(props) => (
                            <td>
                                {t("attribute_type_label." + props.dataItem.attributeType.toLowerCase().split(" ").join("_"), { ns: "attribute/attribute_type" })}
                            </td>
                        )}
                    /> */}
                    <Column
                        width={180}
                        headerCell={() => (
                            <th>
                                {t("grid.header.permission", { ns: "role/properties_rights" })}
                                <span title={t("grid.header.permission_info", { ns: "role/properties_rights" })} className='ms-2'>
                                    <i class="fas fa-circle-info text-primary"></i>
                                </span>
                            </th>
                        )}
                        cell={(props) => (
                            <td>
                                <GlobalContext.Consumer>
                                    {value => (
                                        <DropDownList
                                            disabled={
                                                props.dataItem.isAzureAttribute ||
                                                state.attributeInProgressItems.includes(props.dataItem._id) ||
                                                value.state.subscription.rolesPermission === "Read only"
                                            }
                                            onChange={(dataItem) => this.handlePermission(props.dataItem, dataItem)}
                                            data={this.getAccessData(props.dataItem)}
                                            value={this.getAccessValue(props.dataItem)}
                                            textField={"text"}
                                        />
                                    )}

                                </GlobalContext.Consumer>
                            </td>
                        )}
                    />
                    <Column
                        width={45}
                        title=""
                        cell={(props) => (
                            <td>
                                {state.attributeInProgressItems.includes(props.dataItem._id) && <InProgressComponent />}
                                {state.attributeSavedItems.includes(props.dataItem._id) && <SavingComponent />}
                            </td>
                        )}
                    />
                </Grid>
            </div>
        )
    }

    getData = async () => {
        let attributeRelations = await getAttributes(this.props.selectedEntity._id)
        let SystemAttr = attributeRelations.filter(attr => attr.isSystemAttribute)
        let NormalAttr = attributeRelations.filter(attr => !attr.isSystemAttribute)

        attributeRelations = [...NormalAttr, ...SystemAttr]

        attributeRelations.forEach((attr, index) => {
            attr.indexId = index + 1
            attr.typeText = this.DataTypes.find(type => type.value === attr.attributeType)?.text
            if (attr.attributeType === "Entity Lookup") {
                attr.typeText = "Referenced Property"
            }
        })
        return attributeRelations
    }

    getAccessData = (attribute) => {
        const filteredAccessMap = this.getFilteredAccessOptions(attribute)
        return this.getAccessDataMap(filteredAccessMap)
    }

    getAccessDataMap = (data) => {
        const { t } = this.props
        return data.map(item => {
            const key = item.key.toLowerCase().split(" ").join("_")
            const text = t("dropdown_values." + key)
            return {
                ...item,
                text
            }
        })
    }

    getAccessValue = (attribute) => {
        const { selectedRole } = this.context.state
        const filteredAccessMap = this.getFilteredAccessOptions(attribute)
        if (!filteredAccessMap.length) return null
        if (!selectedRole) return this.getAccessValueMap(filteredAccessMap[0])
        const attributeConfig = attribute.roleRights[selectedRole._id]
        if (!attributeConfig) return this.getAccessValueMap(filteredAccessMap[0])
        let permission = filteredAccessMap.find(item => item.attribute === attributeConfig.permission)
        if (!permission && attribute.attributeType === "Attachment") {
            const legacyOwnPermissions = ["Own", "Own files only"]
            if (legacyOwnPermissions.includes(attributeConfig.permission)) {
                permission = filteredAccessMap.find(item => item.key === "Own files only")
            }
        }
        if (!permission) {
            permission = filteredAccessMap[0]
        }
        return this.getAccessValueMap(permission)
    }

    getAccessValueMap = (accessMapValue) => {
        if (!accessMapValue) return accessMapValue
        const { t } = this.props
        const key = accessMapValue.key.toLowerCase().split(" ").join("_")
        const text = t("dropdown_values." + key)
        return {
            ...accessMapValue,
            text
        }
    }

    getFilteredAccessOptions = (attribute) => {
        const baseOptions = this.getBaseAccessOptions(attribute)
        const filteredOptions = attribute.attributeType === "Attachment"
            ? baseOptions
            : baseOptions.filter(option => option.key !== "Read only download")

        const { state } = this.context
        const { selectedRole, selectedEntity } = state

        if (!selectedRole || !selectedEntity) return filteredOptions

        const entityConfig = selectedEntity.roleRights?.[selectedRole._id]
        if (!entityConfig) return filteredOptions

        if (this.entityHasFullAccess(entityConfig)) {
            if (attribute.isSystemAttribute) {
                return filteredOptions.filter(option => option.key !== "Full access")
            }
            return filteredOptions
        }

        if (this.entityIsReadOnly(entityConfig)) {
            let readonlyOptions = filteredOptions.filter(option => option.key !== "Full access")
            if (attribute.attributeType === "Attachment") {
                readonlyOptions = readonlyOptions.filter(option => option.key !== "Own files only")
            }
            return readonlyOptions
        }

        return filteredOptions.filter(option => option.key === "No access")
    }

    getBaseAccessOptions = (attribute) => {
        const options = attribute.attributeType === "Attachment" ? attachmentAccessMap : accessMap
        return options.filter(option => option.key !== "Self only")
    }

    entityHasFullAccess = (entityConfig) => {
        return entityConfig.create && entityConfig.read && entityConfig.update
    }

    entityIsReadOnly = (entityConfig) => {
        return (
            !entityConfig.create &&
            entityConfig.read &&
            !entityConfig.update &&
            !entityConfig.delete
        )
    }

    selectItem = (dataItem) => {
        const { dispatch } = this.context
        dispatch({ type: "SET_SELECTED_ATTRIBUTE", payload: dataItem })
    }

    handlePermission = async (attribute, dataItem) => {
        const { state, dispatch } = this.context
        const { selectedRole } = state
        const permission = dataItem.value
        const { roleRights } = attribute
        roleRights[selectedRole._id].permission = permission.attribute
        attribute.roleRights = roleRights
        dispatch({ type: "ATTRIBUTE_ADD_TO_INPROGRESS", payload: attribute._id })
        updateAttribute(attribute._id, { roleRights })
        dispatch({ type: "UPDATE_ATTRIBUTES", payload: { _id: attribute._id, properties: attribute } })
        dispatch({ type: "ATTRIBUTE_MOVE_TO_SAVE", payload: attribute._id })
        this.selectItem(attribute)
    }
}

export default withTranslation([
    "role/properties_rights",
    "attribute/attribute_type",
], {
    withRef: true,
})(AttributeRights);
